import {
  createTranslationMessages,
  createTranslationRef,
} from '@backstage/core-plugin-api/alpha';

// TODO импортировать как import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';
/** @alpha */
export const techdocsTranslationRef = createTranslationRef({
  id: 'techdocs',
  messages: {
    search: {
      placeholder: 'Поиск документации {{entityTitle}}',
      noResults: 'Ничего не найдено',
    },
    error: {
      couldNotLoad: 'Не удалось загрузить доступную документацию.',
    },
    nav: {
      title: 'Документация',
    },
    table: {
      columns: {
        type: 'Тип',
        document: 'Документ',
        kind: 'Вид',
        owner: 'Владелец',
      },
      body: {
        emptyDataSourceMessage: 'Нет записей для отображения',
      },
      header: {
        actions: 'Действия',
      },
      title: {
        all: 'Все',
      },
      toolbar: {
        searchPlaceholder: 'Фильтр',
      },
      actions: {
        addToFavorites: 'Добавить в избранное',
        removeFromFavorites: 'Убрать из избранного',
        copyDocsUrl: 'Нажмите, чтобы скопировать ссылку на документацию в буфер обмена',
      },
      pagination: {
        labelRowsSelect: 'строк',
      },
      emptyState: {
        title: 'Нет документов для отображения',
        description:
          'Создайте собственную документацию. Ознакомьтесь с нашим руководством для начала работы.',
        docsButton: 'DOCS',
      },
    },
    home: {
      supportButton: 'Изучите документацию в своей экосистеме.',
    },
    aboutCard: {
      viewTechdocs: 'Открыть TechDocs',
    },
    notFound: {
      title: 'Документация не найдена',
      builderNote:
        'Обратите внимание: в вашей конфигурации techdocs.builder не установлен в `local`, поэтому это приложение Backstage не будет генерировать документацию, если она не найдена. Убедитесь, что документация проекта сгенерирована и опубликована внешним процессом, например CI/CD pipeline. Либо измените techdocs.builder на `local`, чтобы генерировать документацию в этом экземпляре Backstage.',
    },
    buildLogs: {
      title: 'Детали сборки',
      closeDrawer: 'Закрыть панель',
      showBuildLogs: 'Показать логи сборки',
      waitingForLogs: 'Ожидание логов...',
    },
    stateIndicator: {
      initialBuild: {
        message:
          'Документация открывается впервые и подготавливается. Последующие загрузки будут значительно быстрее.',
      },
      contentStaleRefreshing: {
        message:
          'Готовится более новая версия этой документации, она скоро станет доступна.',
      },
      contentStaleReady: {
        message:
          'Доступна более новая версия этой документации. Обновите страницу, чтобы её увидеть.',
        refreshButton: 'Обновить',
      },
      contentStaleError: {
        message:
          'Не удалось собрать более новую версию этой документации.',
      },
    },
    redirectNotification: {
      redirectNow: 'Перейти сейчас',
    },
    readerPageHeader: {
      source: 'Источник',
      owner: 'Владелец',
      lifecycle: 'Жизненный цикл',
    },
    pageWrapper: {
      title: 'Документация',
      subtitle: 'Документация, доступная в {{orgName}}',
    },
    entityContent: {
      title: 'TechDocs',
    },
    reader: {
      settings: 'Настройки',
    },
  },
});

export default createTranslationMessages({
  ref: techdocsTranslationRef,
  messages: {
    'search.placeholder': 'Поиск по документации {{entityTitle}}',
    'search.noResults': 'Ничего не найдено',
    'error.couldNotLoad': 'Не удалось загрузить доступную документацию.',
    'nav.title': 'Документация',
    'table.columns.type': 'Тип',
    'table.columns.document': 'Документ',
    'table.columns.kind': 'Вид',
    'table.columns.owner': 'Владелец',
    'table.body.emptyDataSourceMessage': 'Нет записей для отображения',
    'table.header.actions': 'Действия',
    'table.title.all': 'Все',
    'table.toolbar.searchPlaceholder': 'Фильтр',
    'table.actions.addToFavorites': 'Добавить в избранное',
    'table.actions.removeFromFavorites': 'Убрать из избранного',
    'table.actions.copyDocsUrl':
      'Нажмите, чтобы скопировать ссылку на документацию в буфер обмена',
    'table.pagination.labelRowsSelect': 'строк',
    'table.emptyState.title': 'Нет документов для отображения',
    'table.emptyState.description':
      'Создайте собственную документацию. Ознакомьтесь с информацией для начала работы.',
    'table.emptyState.docsButton': 'DOCS',
    'home.supportButton': 'Изучите документацию в своей экосистеме.',
    'aboutCard.viewTechdocs': 'Открыть TechDocs',
    'notFound.title': 'Документация не найдена',
    'notFound.builderNote':
      "Обратите внимание, что в вашей конфигурации techdocs.builder не установлен в 'local', поэтому это приложение Backstage не будет генерировать документацию, если она не найдена. Убедитесь, что документация проекта сгенерирована и опубликована внешним процессом, например CI/CD. Либо измените techdocs.builder на 'local', чтобы генерировать документацию из этого экземпляра Backstage.",
    'buildLogs.title': 'Детали сборки',
    'buildLogs.closeDrawer': 'Закрыть панель',
    'buildLogs.showBuildLogs': 'Показать логи сборки',
    'buildLogs.waitingForLogs': 'Ожидание логов...',
    'stateIndicator.initialBuild.message':
      'Документация открывается впервые и подготавливается. Последующие загрузки будут значительно быстрее.',
    'stateIndicator.contentStaleRefreshing.message':
      'Готовится более новая версия этой документации, она скоро станет доступна.',
    'stateIndicator.contentStaleReady.message':
      'Доступна более новая версия этой документации. Обновите страницу, чтобы её увидеть.',
    'stateIndicator.contentStaleReady.refreshButton': 'Обновить',
    'stateIndicator.contentStaleError.message':
      'Не удалось собрать более новую версию этой документации.',
    'redirectNotification.redirectNow': 'Перейти сейчас',
    'readerPageHeader.source': 'Источник',
    'readerPageHeader.owner': 'Владелец',
    'readerPageHeader.lifecycle': 'Жизненный цикл',
    'pageWrapper.title': 'Документация',
    'pageWrapper.subtitle': 'Документация, доступная в {{orgName}}',
    'entityContent.title': 'TechDocs',
    'reader.settings': 'Настройки',
  },
});
